/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_Spec_DescriptionInputs */



/**
* | output |
* | --- |
* | "Upload the API's OpenAPI or Swagger file (JSON). The assistant then reads it from here instead of searching the API for it in every conversation — faster, ch..." |
*
* @param {Integrations_Apis_Spec_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_spec_description = /** @type {((inputs?: Integrations_Apis_Spec_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Spec_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Laden Sie die OpenAPI- oder Swagger-Datei der API hoch (JSON). Der Assistent liest sie dann von hier, statt die API in jeder Unterhaltung erneut danach zu durchsuchen – schneller, günstiger und auch für APIs geeignet, deren Beschreibung nicht öffentlich verfügbar ist.")
	return /** @type {LocalizedString} */ ("Upload the API's OpenAPI or Swagger file (JSON). The assistant then reads it from here instead of searching the API for it in every conversation — faster, cheaper, and it also works for an API whose description is not published publicly.")
});